// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

// Internal Dependencies
import { IsEmpty } from '../../common/checks';

const SortArrow = ({ currentOrder, onSort }) => {
  const onSortHandler = (order = '') => {
    onSort(order);
  };

  if (IsEmpty(currentOrder)) return <UnfoldMoreIcon onClick={() => onSortHandler('ASC')} />;

  return (
    currentOrder === 'ASC' ? <ArrowUpwardIcon onClick={() => onSortHandler('DESC')} /> : <ArrowDownwardIcon onClick={() => onSortHandler('ASC')} />
  );
};

SortArrow.defaultProps = {
  currentOrder: '',
  onSort:       () => {},
};

SortArrow.propTypes = {
  currentOrder: PropTypes.string,
  onSort:       PropTypes.func,
};

export default SortArrow;
